import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Row, Col, Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import { FaClock, FaCamera, FaSearch, FaTimes, FaHome, FaFileContract } from "react-icons/fa";
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../constants';

import IconLeaseInvited from '../../../assets/icon/report-card.png'
import IconLeaseDelete from '../../../assets/icon/delete.png'
import IconLeaseUpdate from '../../../assets/icon/updated.png'
import IconInspSign from '../../../assets/icon/signed.png'
import IconInspCompleted from '../../../assets/icon/insCompletd.png'
import IconInspCreated from '../../../assets/icon/completedIcon.png'
import IconInspDelete from '../../../assets/icon/delete.png'
import IconProperty from '../../../assets/icon/flathome.png'
import IconPropertyActivity from '../../../assets/icon/camIcon.png'

function PropertyTimeline(props) {
	const [timelineData, setTimelineData] = useState([]);
	const [modalOpen, setModalOpen] = useState(false);
	const [modalContent, setModalContent] = useState(null);
	const [propertyName, setPropertyName] = useState('');
	const { id } = useParams();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location.state && location.state.property) {
			const { property } = location.state;
			const propertyData = property.find(item => item.id === parseInt(id));
			if (propertyData) {
				setPropertyName(propertyData.name);
			}
		}
	}, [id, location.state]);

	useEffect(() => {
		const token = localStorage.getItem('token');
		fetch(`${BASE_URL}/property/${id}/timeline`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
			.then(response => response.json())
			.then(data => {
				if (data.status) {
					setTimelineData(Object.keys(data.result).length === 0 ? [] : data.result);
				} else {
					console.error("Error: Unable to fetch.");
				}
			})
			.catch(error => console.error("Error fetching data:", error));
	}, [id]);

	const toggleModal = () => setModalOpen(!modalOpen);

	const handlePopover = (content) => {
		setModalContent(content);
		toggleModal();
	};

	const getIcon = (type, data) => {
		if (type === 'INSPECTION') {
			if (data.action) {
				if (data.action === 'SIGNED') {
					return <img src={IconInspSign} alt="Show" height={25} draggable="false" />;
				}
				if (data.action === 'COMPLETED') {
					return <img src={IconInspCompleted} alt="Show" height={25} draggable="false" />;
				}
				if (data.action === 'CREATED' || data.action === 'UPDATED') {
					return <img src={IconInspCreated} alt="Show" height={25} draggable="false" />;
				}
				if (data.action === 'DELETED') {
					return <img src={IconInspDelete} alt="Show" height={25} draggable="false" />;
				}
			}
			return <FaSearch />;
		} 
		
		else if (type === 'PROPERTY') {
			return <img src={IconProperty} alt="Show" height={25} draggable="false" />;
			// return <FaHome />;
		} 
		
		else if (type === 'PROPERTY_LEASE') {
			if (data.action) {
				if (data.action === 'INVITED' || data.action === 'CREATED') {
					return <img src={IconLeaseInvited} alt="Show" height={25} draggable="false" />;
				}
				if (data.action === 'DELETED') {
					return <img src={IconLeaseDelete} alt="Show" height={25} draggable="false" />;
				}
				if (data.action === 'UPDATED') {
					return <img src={IconLeaseUpdate} alt="Show" height={25} draggable="false" />;
				}
			}
			return <FaFileContract />;
		} 
		
		else if (type === 'PROPERTY_ACTIVITY_IMAGES') {
			return <img src={IconPropertyActivity} alt="Show" height={25} draggable="false" />;
			// return <FaCamera />;
		} 
		
		return <FaFileContract />;
	};

	const handleClick = (type, data) => {
		if (type === 'PROPERTY_ACTIVITY_IMAGES') {
			handlePopover(data);
		} else if (type === 'INSPECTION') {
			navigate(`/inspection/view/${data.inspection_id}`);
		}
		else if (type === 'PROPERTY') {
			navigate(`/property/edit/${data.property_id}`);
		}
		else if (type === 'PROPERTY_LEASE') {
			navigate(`/lease/edit/${data.lease_id}`);
		}
	};

	// console.log({timelineData})

	return (
		<div className="content">
			<h3>{propertyName}</h3>
			{
				timelineData.length === 0 ? (
					<p>No timeline data available.</p>
				) : (
					Object.entries(timelineData).map(([date, entries], index) => {
						return (
							<Card key={index} className="mb-3" style={{overflow: 'hidden'}}>
								<CardTitle className="font-weight-bold" >
									<Row style={{ backgroundColor: '#404040', color: 'white', padding: '10px 5px', margin: 0 }}>
										<Col xs="12">
											<span style={{ fontSize: '18px' }}>{new Date(date).toLocaleDateString('en-US')}</span>
										</Col>
									</Row>
								</CardTitle>
								<CardBody>
									{entries.map((item, idx) => {
										const { type, data } = item;
										const icon = getIcon(type, data);

										return (
											<div key={idx}>
											<Row className="align-items-center" onClick={() => handleClick(type, data)}>
												<Col xs="1" className='text-center'>
													<span style={{ fontSize: '20px' }}>{icon}</span>
												</Col>
												<Col>
													<span style={{ fontSize: '17px', cursor: 'pointer' }}>
														{data.message}
													</span>
												</Col>
											</Row>
											<hr />
											</div>
										);
									})}
								</CardBody>
							</Card>
						);
					})
				)}

			{/* Custom Modal for PROPERTY_ACTIVITY_IMAGES */}
			<Modal isOpen={modalOpen} toggle={toggleModal} centered size="md">
				<ModalHeader toggle={toggleModal} style={{ display: 'flex', justifyContent: 'space-between' }}
					close={
						<button className="close" onClick={toggleModal} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
							<FaTimes size={20} />
						</button>
					}>
					Property Details
				</ModalHeader>
				<ModalBody>
					{modalContent && (
						<div style={{ textAlign: 'center' }}>
							{modalContent.image && (
								<img src={modalContent.image} alt="property" style={{ marginBottom: '10px', height: '250px' }} />
							)}
							<Table bordered>
								<tbody>
									{modalContent.area_name && (
										<tr>
											<td><strong>Area Name</strong></td>
											<td>{modalContent.area_name}</td>
										</tr>
									)}
									{modalContent.item_name && (
										<tr>
											<td><strong>Item Name</strong></td>
											<td>{modalContent.item_name}</td>
										</tr>
									)}
									{modalContent.activity && (
										<tr>
											<td><strong>Activity</strong></td>
											<td>{modalContent.activity}</td>
										</tr>
									)}
									{modalContent.action && (
										<tr>
											<td><strong>Action</strong></td>
											<td>{modalContent.action}</td>
										</tr>
									)}
									{modalContent.priority && (
										<tr>
											<td><strong>Priority</strong></td>
											<td>{modalContent.priority}</td>
										</tr>
									)}
									{modalContent.comments && (
										<tr>
											<td><strong>Comments</strong></td>
											<td>{modalContent.comments || 'N/A'}</td>
										</tr>
									)}
								</tbody>
							</Table>
						</div>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
}

export default PropertyTimeline;
